t = require('views/internal/teacup-with-helpers')('ent_board_details')

module.exports = t.renderable (boardAdminsNamesList, dateCreated, dateLastActivity, boardUrl) ->
  t.div '.board-details-popover', ->

    t.div '.board-details-section', ->
      if boardAdminsNamesList.length > 1
        t.div '.board-details-section-title', ->
          t.format 'board-administrators'
      else
        t.div '.board-details-section-title', ->
          t.format 'board-administrator'
      t.div '.board-details-section-description', ->
        t.text boardAdminsNamesList.join(', ')

    t.div '.board-details-section', ->
      t.div '.board-details-section-title', ->
        t.format 'creation-date'
      t.div '.board-details-section-description', ->
        t.text dateCreated

    t.div '.board-details-section', ->
      t.div '.board-details-section-title', ->
        t.format 'latest-activity'
      t.div '.board-details-section-description', ->
        if dateLastActivity
          t.text dateLastActivity
        else
          t.format 'no-activity-recorded'

    t.a { class: 'buttonPrimary', href: boardUrl }, ->
      t.format 'view-board'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/ent_board_detail.coffee